import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ref, push, serverTimestamp } from 'firebase/database';
import { db } from '../firebase/config';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Admin sayfasını takip etme
    if (location.pathname === '/admin') {
      return;
    }

    const trackVisit = async () => {
      try {
        await push(ref(db, 'visits'), {
          page: location.pathname,
          timestamp: serverTimestamp(),
          userAgent: navigator.userAgent
        });
      } catch (error) {
        // Sessizce hata yok say (kullanıcı deneyimini bozmamak için)
        console.error('Ziyaret kaydedilemedi:', error);
      }
    };

    // Kısa bir gecikme ile kaydet (sayfa yüklenmesini engellememek için)
    const timeoutId = setTimeout(trackVisit, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [location.pathname]);
};
